var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-record-wrapper"},[(_vm.imgList.length > 0)?_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":"","srcset":""}})}):[_c('div',{staticClass:"no-data"},[_vm._v("\n      暂无数据\n    ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }